import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { userReducer } from '@src/store/ducks/user/reducer'
import { authReducer } from '@src/store/ducks/auth/reducer'
import { appReducer } from '@src/store/ducks/app/reducer'
import { promotionReducer } from '@src/store/ducks/promotion/reducer'
import { payReducer } from '@src/store/ducks/pay/reducer'
import { tariffsReducer } from '@src/store/ducks/tariffs/reducer'
import { addressReducer } from '@src/store/ducks/address/reducer'
import { contactsReducer } from '@src/store/ducks/contacts/reducer'
import { subscriptionsReducer } from '@src/store/ducks/subscriptions/reducer'

const combinedReducer = combineReducers({
  user: userReducer,
  isAuth: authReducer,
  app: appReducer,
  promotion: promotionReducer,
  pay: payReducer,
  tariffs: tariffsReducer,
  address: addressReducer,
  contacts: contactsReducer,
  subscriptions: subscriptionsReducer,
})

const rootReducer = (state: any, action: any) => {
  let tmpState = state
  if (action.type === 'auth/logoutAC') {
    tmpState = undefined
  }
  return combinedReducer(tmpState, action)
}

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
